"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alt_1 = require("../../alt");
var curation_actions_1 = require("../actions/curation_actions");
var curation_source_1 = require("../sources/curation_source");
var CURATE_ERROR = 'Error adding to curated set.';
var DECURATE_ERROR = 'Error removing from curated set.';
var FETCH_ERROR = 'Error fetching curated sets.';
var CurationStore = /** @class */ (function () {
    function CurationStore() {
        this.state = this.initialState();
        this.registerAsync(curation_source_1.default);
        this.bindListeners({
            handleFetchIndex: curation_actions_1.default.FETCH_INDEX,
            handleSetIndex: curation_actions_1.default.SET_INDEX,
            handleStopCurating: curation_actions_1.default.STOP_CURATING,
            handleCurate: curation_actions_1.default.CURATE,
            handleCurateSuccess: curation_actions_1.default.CURATE_SUCCESS,
            handleCurateError: curation_actions_1.default.CURATE_ERROR,
            handleDecurate: curation_actions_1.default.DECURATE,
            handleDecurateSuccess: curation_actions_1.default.DECURATE_SUCCESS,
            handleDecurateError: curation_actions_1.default.DECURATE_ERROR,
        });
    }
    CurationStore.prototype.handleFetchIndex = function (params) {
        this.setState(Object.assign(this.initialState(), params, { isCurating: true }));
        this.getInstance().fetchIndex();
    };
    CurationStore.prototype.handleFetchError = function () {
        this.setState({ error: FETCH_ERROR });
    };
    CurationStore.prototype.handleSetIndex = function (response) {
        this.state.listing_curated_sets = response.listing_curated_sets;
    };
    CurationStore.prototype.handleCurate = function (curatedSetId) {
        this.setState({ curated_set_id: curatedSetId });
        this.getInstance().curate();
    };
    CurationStore.prototype.findSelectedCuratedSet = function () {
        var _this = this;
        var findBy = function (set) { return set.curated_set_id === _this.state.curated_set_id; };
        return this.state.listing_curated_sets.find(findBy);
    };
    CurationStore.prototype.handleCurateSuccess = function () {
        this.findSelectedCuratedSet().curated = true;
    };
    CurationStore.prototype.handleCurateError = function () {
        this.setState({ error: CURATE_ERROR });
    };
    CurationStore.prototype.handleDecurateSuccess = function () {
        this.findSelectedCuratedSet().curated = false;
    };
    CurationStore.prototype.handleDecurateError = function () {
        this.setState({ error: DECURATE_ERROR });
    };
    CurationStore.prototype.handleDecurate = function (curatedSetId) {
        this.setState({ curated_set_id: curatedSetId });
        this.getInstance().decurate();
    };
    CurationStore.prototype.handleStopCurating = function () {
        this.setState(this.initialState());
    };
    CurationStore.prototype.initialState = function () {
        return {
            comparison_shopping_page_id: null,
            curated_set_id: null,
            error: null,
            isCurating: false,
            listing_curated_sets: [],
            product_id: null,
        };
    };
    return CurationStore;
}());
exports.default = alt_1.default.createStore(CurationStore, 'CurationStore');
//# sourceMappingURL=curation_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/stores/curation_store.js
// module id = gwkt
// module chunks = 20 21